import Instance from './instance.js'

/**
 * Represents a InstanceString instance.
 * @extends Instance
 */
class InstanceString extends Instance {}

export default InstanceString
